/*
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../lib/@waca/baglass/js/baglass/app/plugins/Button'
], function(BaseClass) {

	/**
	 * Action which allows a plugin button to be seen, but is disabled
	 */
	class DisabledActionHandler extends BaseClass {
		onRender(context) {
			context.target.plugin.disable();
		}
	}

	return DisabledActionHandler;
});
